/**
 * Pass in a `Theme` and get back the corresponding display name.
 */
export const THEME_NAMES = {
    AUTO: 'Automatic (system theme)',
    DARK: 'Dark',
    LIGHT: 'Light',
};
/**
 * Pass in a `Theme` and get back the corresponding icon name.
 */
export const THEME_ICONS = {
    AUTO: 'System',
    DARK: 'ClearNight',
    LIGHT: 'Sunny',
};
/**
 * The key used to store the user's theme preference in local storage.
 */
export const THEME_STORAGE_KEY = 'theme';
